export default __webpack_public_path__ + "static/media/a-day-at-the-zoo.44a3423d.png";